import { useEffect, useState} from 'react';
import axios from 'axios';

const useGetContacto = (token) => {
    const [contacto, setContacto] = useState({ LOADING: true });

    useEffect(() => {
        const data = async () => {
            const form_data = new FormData();
            form_data.append('idToken', token);
            const response = await axios.post(process.env.REACT_APP_API_URL+'?getContacto=true', form_data);

            if(response.data.STATUS && response.data.STATUS === "SUCCESS"){
                setContacto(response.data);

            } else if(response.data.STATUS && response.data.STATUS === "ERROR"){
                setContacto(response.data);

            } else {
                setContacto(
                    {
                        STATUS : "ERROR",
                        ERROR: {
                            ID : "error-get-contacto",
                            MESSAGE : "No se pudo obtener la información de contacto."
                        }
                    }
                );

            }
        }

        data()
            .catch(console.error);
    }, [token]); 
    return contacto;
}

export default useGetContacto;